export enum ProjectMembershipRole {
  OWNER = 'Owner',
  ADMIN = 'Admin',
  USER = 'User'
}

export default ProjectMembershipRole
